import { PermitDocument } from "../types/permits";
import { CoordinationPermit_normalize } from "../types/permits/CoordinationPermit";
import { DivingPermit_normalize } from "../types/permits/DivingPermit";
import { EnergyHarbourPermit_normalize } from "../types/permits/EnergyHarbourPermit";
import { GeneralDepartmentPermit_normalize } from "../types/permits/GeneralDepartmentPermit";
import { HotWorkOnShipPermit_normalize } from "../types/permits/HotWorkOnShipPermit";
import { HullCleaningPermit_normalize } from "../types/permits/HullCleaningPermit";
import { MaritimeEvent_normalize } from "../types/permits/MaritimeEvent";
import { ShipRepairsPermit_normalize } from "../types/permits/ShipRepairsPermit";
import { UnderWaterWorKPermit_normalize } from "../types/permits/UnderWaterWorkPermit";
import { PermitType } from "./enums";

export function permitPageUrl(args: {
    permitType: PermitType;
    workPermitId?: number;
    departmentId?: number;
    documentReferenceId?: string;
    sequenceIdentifier?: string;
    copyOfDocumentReferenceId?: string;
}): string {
    const baseUrl =
        args.permitType === PermitType.GeneralDepartmentPermit
            ? `/Permits/${PermitType.GeneralDepartmentPermit}/${args.departmentId}`
            : `/Permits/${args.permitType}`;

    const queryParams = args.documentReferenceId
        ? `DocumentReferenceId=${args.documentReferenceId}`
        : args.workPermitId
        ? `WorkPermitId=${args.workPermitId}`
        : args.sequenceIdentifier
        ? `SequenceIdentifier=${args.sequenceIdentifier}`
        : args.copyOfDocumentReferenceId
        ? `CopyOfDocumentReferenceId=${args.copyOfDocumentReferenceId}`
        : "";

    return `${baseUrl}?${queryParams}`;
}

const permitNormalizationHandlers = {
    [PermitType.EnergyHarbourPermit]: EnergyHarbourPermit_normalize,
    [PermitType.GeneralDepartmentPermit]: GeneralDepartmentPermit_normalize,
    [PermitType.UnderWaterWorkPermit]: UnderWaterWorKPermit_normalize,
    [PermitType.DivingPermit]: DivingPermit_normalize,
    [PermitType.CoordinationPermit]: CoordinationPermit_normalize,
    [PermitType.MaritimeEvent]: MaritimeEvent_normalize,
    [PermitType.ShipRepairsPermit]: ShipRepairsPermit_normalize,
    [PermitType.HullCleaningPermit]: HullCleaningPermit_normalize,
    [PermitType.HotWorkOnShipPermit]: HotWorkOnShipPermit_normalize
} as const;

export function normalizePermit<TDocument extends PermitDocument>(permit: TDocument): TDocument {
    const normalizablePermitTypes = Object.keys(permitNormalizationHandlers);

    if (!normalizablePermitTypes.includes(permit.permitName)) {
        console.error(`Attempted to normalize non normalizable permit type: ${permit.permitName}`);
        return permit;
    }

    const normalizedPermit = permitNormalizationHandlers[permit.permitName](permit as any) as TDocument;
    return normalizedPermit;
}

export function versionedSequenceIdentifier(args: { sequenceIdentifier: string; version: number }): string {
    const paddedVersion = args.version.toString().padStart(2, "0");

    return `${args.sequenceIdentifier}-${paddedVersion}`;
}
